import { createSlice } from '@reduxjs/toolkit';

import { loadSolutions } from '../thunks/solutions.thunk';
import { ISolutionsState } from './types';

export const SEARCH_LIMIT = 60;
export const SEARCH_LIMIT_V2 = 6;
export const VESPA_SEARCH_RESULTS_LIMIT = 200;

const initialState: ISolutionsState = {
  query: '',
  solutions: null,
  error: null,
  isLoading: false,
  // Search can be also triggered by back button or history restoration
  isUserTypedSearch: false,
  paging: {
    hasMore: true,
  },
};

export const solutionsSlice = createSlice({
  name: 'solutions',
  initialState,
  reducers: {
    setIsUserTypedSearch: (state, action) => {
      state.isUserTypedSearch = action.payload;
    },
    resetSolutions: (state) => ({
      ...initialState,
      isUserTypedSearch: state.isUserTypedSearch,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(loadSolutions.pending, (state, action) => {
      return {
        ...state,
        query: action.meta.arg.query,
        error: null,
        isLoading: true,
      };
    });

    builder.addCase(loadSolutions.fulfilled, (state, action) => {
      const solutions = [...(state.solutions ?? []), ...action.payload];

      return {
        ...state,
        solutions,
        error: null,
        isLoading: false,
        isUserTypedSearch: false,
        paging: { hasMore: false },
      };
    });

    builder.addCase(loadSolutions.rejected, (state, action) => {
      return {
        ...state,
        error: action.error as string,
        isLoading: false,
        isUserTypedSearch: false,
      };
    });
  },
});
